import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/auth/authSlice";
import nicknameReducer from "../features/nickname/nicknameSlice";
import { noleyoApi } from "../services/api";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    nickname: nicknameReducer,
    [noleyoApi.reducerPath]: noleyoApi.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(noleyoApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
